import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const GithubIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#24292F"
      fillRule="evenodd"
      d="M9.97 1A9.1 9.1 0 0 0 1 10.23a9.2 9.2 0 0 0 6.14 8.75c.44.1.6-.2.6-.44l-.01-1.71c-2.5.55-3.02-1.1-3.02-1.1-.4-1.07-1-1.35-1-1.35-.8-.56.07-.56.07-.56.9.06 1.38.95 1.38.95.8 1.4 2.1 1 2.61.76.08-.6.32-1 .57-1.24-2-.21-4.09-1-4.09-4.55 0-1 .36-1.83.92-2.48-.08-.22-.4-1.17.1-2.44 0 0 .75-.24 2.46.95a8.5 8.5 0 0 1 4.49 0c1.7-1.2 2.46-.95 2.46-.95.5 1.27.18 2.22.1 2.44.57.65.91 1.47.91 2.48 0 3.54-2.1 4.32-4.1 4.55.33.3.61.84.61 1.71l-.01 2.54c0 .24.16.53.6.44a9.2 9.2 0 0 0 6.14-8.75A9.1 9.1 0 0 0 9.97 1"
      clipRule="evenodd"
      className={_styles.darkInvert}
    />
  </svg>
);
